export default __webpack_public_path__ + "static/media/auth-illustration-people.904e0e99.svg";